var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatchNewLogoOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9959 0H12.0005C5.37205 0 0 5.37182 0 12C0 18.6282 5.37205 24 12.0005 24H29.9995C36.628 24 42 18.6282 42 12C41.9965 5.37182 36.6244 0 29.9959 0ZM35.9842 12.385C35.7847 15.4471 33.1598 17.9003 29.9926 17.9947C28.0397 18.0507 26.3424 17.1793 25.1105 15.909C24.848 15.6396 24.3615 15.1916 23.9905 14.8486C23.875 14.7436 23.7736 14.6492 23.6896 14.5687C22.1847 13.1688 19.8189 13.1688 18.3105 14.5687C18.2475 14.6282 18.174 14.6947 18.0935 14.7681C17.712 15.1216 17.1696 15.6185 16.8896 15.909C15.6577 17.1793 13.9604 18.0507 12.0075 17.9947C8.84028 17.9003 6.21199 15.4471 6.01252 12.385C5.78851 8.89588 8.64079 5.99824 12.1965 5.99824C14.0759 5.99824 15.6717 6.88364 16.8896 8.08749C17.1696 8.36394 17.7051 8.81188 18.1145 9.15134C18.237 9.25284 18.349 9.34731 18.4365 9.42081C19.9134 10.6667 22.0867 10.6667 23.5636 9.42081C23.6336 9.36131 23.7176 9.29134 23.8085 9.21785C24.2285 8.86788 24.813 8.38146 25.114 8.08749C26.3353 6.88364 27.9313 5.99824 29.807 5.99824C33.3557 5.99824 36.208 8.89588 35.9842 12.385Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchNewLogoOnly);
export default __webpack_public_path__ + "static/media/batch-new-logo-only.056f1bcd971c4accf33767eb024d3695.svg";
export { ForwardRef as ReactComponent };